/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Set_Team_BInputs */

const en_us2_clubs_set_team_b = /** @type {(inputs: Clubs_Set_Team_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Put in Team B`)
};

const pt_br2_clubs_set_team_b = /** @type {(inputs: Clubs_Set_Team_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colocar no Time B`)
};

const es_419_clubs_set_team_b = /** @type {(inputs: Clubs_Set_Team_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasar al Equipo B`)
};

const pt_pt2_clubs_set_team_b = /** @type {(inputs: Clubs_Set_Team_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pôr na Equipa B`)
};

const fr_fr2_clubs_set_team_b = /** @type {(inputs: Clubs_Set_Team_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre en équipe B`)
};

const de_de2_clubs_set_team_b = /** @type {(inputs: Clubs_Set_Team_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Team B`)
};

const it_it2_clubs_set_team_b = /** @type {(inputs: Clubs_Set_Team_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metti nella Squadra B`)
};

/**
* | output |
* | --- |
* | "Put in Team B" |
*
* @param {Clubs_Set_Team_BInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_set_team_b = /** @type {((inputs?: Clubs_Set_Team_BInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Set_Team_BInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_set_team_b(inputs)
	if (locale === "es-419") return es_419_clubs_set_team_b(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_set_team_b(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_set_team_b(inputs)
	if (locale === "de-DE") return de_de2_clubs_set_team_b(inputs)
	if (locale === "it-IT") return it_it2_clubs_set_team_b(inputs)
	return en_us2_clubs_set_team_b(inputs)
});
export { clubs_set_team_b as "clubs.set_team_b" }